export default __webpack_public_path__ + "static/media/emojis5.d2e6f93b.jpg";